export const COMMON_TITLE = '顺丰校园招聘'



// WEBPACK FOOTER //
// ./src/constants/title.js